import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/mt-follow.png'


const _withScopeId = n => (_pushScopeId("data-v-6017216a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "banner-page" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "mt-banner" }
const _hoisted_4 = { class: "mt-product" }
const _hoisted_5 = { class: "mt-product-title" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-b" }, "ARTWORKS", -1))
const _hoisted_7 = { class: "mt-porduct-content" }
const _hoisted_8 = {
  key: 0,
  class: "product-item"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "item-text" }
const _hoisted_11 = { class: "banner-nav" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "mt-show" }
const _hoisted_14 = { class: "mt-show-title" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-b" }, "Artnews", -1))
const _hoisted_16 = { class: "mt-show-content" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "banner-nav" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-follow" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "mt-follow-title" }, "关注我们"),
  /*#__PURE__*/_createElementVNode("div", { class: "mt-follow-content" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "mt-follow-url",
      src: _imports_0
    })
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.bannerList.length)
      ? (_openBlock(), _createBlock(_component_el_carousel, {
          key: 0,
          "indicator-position": "none",
          arrow: "never"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bannerList, (item) => {
              return (_openBlock(), _createBlock(_component_el_carousel_item, { key: item }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    src: item.cover,
                    alt: ""
                  }, null, 8, _hoisted_2)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", {
            class: "title-s",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onRouterPush('/product')))
          }, "查看全部")
        ]),
        _createElementVNode("div", _hoisted_7, [
          (_ctx.productList.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", {
                  class: "item-cover",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onProduct && _ctx.onProduct(...args)))
                }, [
                  _createElementVNode("img", {
                    class: "cover-url",
                    src: _ctx.productList[_ctx.pIndex].cover + '?x-oss-process=image/auto-orient,1/resize,h_378/quality,q_90'
                  }, null, 8, _hoisted_9)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("li", null, _toDisplayString(_ctx.productList[_ctx.pIndex].author), 1),
                  _createElementVNode("li", null, _toDisplayString(_ctx.productList[_ctx.pIndex].title) + " ,  " + _toDisplayString(_ctx.normalYear( _ctx.productList[_ctx.pIndex].years)), 1),
                  _createElementVNode("li", null, _toDisplayString(_ctx.productList[_ctx.pIndex].material), 1),
                  _createElementVNode("li", null, _toDisplayString(_ctx.productList[_ctx.pIndex].size), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productList, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["nav-box", index==_ctx.pIndex?'cur':'']),
                key: item.id,
                onClick: ($event: any) => (_ctx.onPorudctSelect(index))
              }, null, 10, _hoisted_12))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("div", {
            class: "title-s",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onRouterPush('/show')))
          }, "查看全部")
        ]),
        _createElementVNode("div", _hoisted_16, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.showList[_ctx.sIndex], (item, index) => {
            return _withDirectives((_openBlock(), _createElementBlock("div", {
              class: "show-item",
              key: index,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onRouterPush('/show')))
            }, [
              _createElementVNode("img", {
                class: "show-url",
                src: item.cover + '?x-oss-process=image/auto-orient,1/resize,m_fill,w_242,h_242/quality,q_90'
              }, null, 8, _hoisted_17)
            ])), [
              [_vShow, index < 3]
            ])
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_18, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.showList, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["nav-box", index==_ctx.sIndex?'cur':'']),
              key: index,
              onClick: ($event: any) => (_ctx.onShowSelect(index))
            }, null, 10, _hoisted_19))
          }), 128))
        ])
      ]),
      _hoisted_20
    ])
  ]))
}